import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { FlagGroupTag } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class FlagGroupTagService {
  constructor(protected http: HttpClient) {}

  async list() {
    return this.http.get<FlagGroupTag[]>(`${env.APIUrl}/flagGroupTag`).toPromise();
  }

  async create(flagGroupTag: FlagGroupTag) {
    return this.http.post<FlagGroupTag>(`${env.APIUrl}/flagGroupTag`, flagGroupTag).toPromise();
  }

  async edit(id: number, flagGroupTag: FlagGroupTag) {
    return this.http.put<FlagGroupTag>(`${env.APIUrl}/flagGroupTag/${id}`, flagGroupTag).toPromise();
  }

  async remove(id: number) {
    return this.http.delete<FlagGroupTag>(`${env.APIUrl}/flagGroupTag/${id}`).toPromise();
  }
}
